import LoginReset from './LoginReset';

export default LoginReset;
